import { object_map } from "@pdfking/rfunc"
import { RecordMerge } from "@pdfking/tfunc"
import { defineComponent } from "vue"
import autocomplete from "../constants/autocomplete"
import Double from "./Double"

export default defineComponent({
  computed: {
    options() {
      const content = (autocomplete as any)[this.autocomplete]

      if (content) {
        return RecordMerge({}, this.extra || {}, {
          [content.title || ""]: object_map(
            (c: { name: string }) => c.name,
            (c: { objects: unknown }) => c.objects,
            content.objects
          ),
        })
      }
      return this.extra || {}
    },
  },
  props: [
    "name",
    "value",
    "autocomplete",
    "extra",
    "size_1",
    "size_2",
    "size",
    "manual_size",
    "on_selection",
  ] as const,
  render() {
    return (
      <Double
        name={this.name}
        options={this.options}
        size_1={this.size_1}
        size_2={this.size_2}
        value={this.value}
        on_selection={(v: string) => this.on_selection?.(v)}
      >
        {{
          buttons: () => this.$slots.buttons?.(),
        }}
      </Double>
    )
  },
})
